























































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { enumData, userPrefPageSize } from '@/decorators';
import excel from '@/utils/excel';
import moment, { Moment } from 'moment';
import Logs from './components/logs.vue';
import addOrEdit from './components/addOrEdit.vue';
import detailModal from './components/detailModal.vue';
import messenger from '@/utils/messenger';
import { CreateElement } from 'vue';
import { Modal } from 'ant-design-vue';
import { namespace } from 'vuex-class';
import { yesNoStatus } from '@/enum';
const Common = namespace('common');

@Component({
  components: {
    Logs,
    addOrEdit,
    detailModal,
  },
})
export default class PayAccountListPage extends Vue {
  @Common.State('biz_list') protected biz_list!: TypeStoreCommon.BizConfig;
  // 列表数据
  protected dataList: TypePayAccountList.ListItem[] = [];
  // 表格列
  protected columns: TypeBase.TableColumn[] = [];
  // 选中的项
  protected selectedList: number[] = [];
  // 状态
  @enumData('Finance/PayAccountStatusEnum')
  protected payAccountStatusEnum: TypeBase.EnumListItem[] = [];
  /** 是否为第三方支付 */
  @enumData('Finance/PaymentAccountUnOfficialEnum')
  protected paymentAccountUnOfficialEnum: TypeBase.EnumListItem[] = [];
  // 银行列表
  protected bankList: TypeCommon.BankItem[] = [];

  // 账户列表
  protected accountList: any = [];
  // 搜索项
  protected searchData: TypePayAccountList.SearchData = {};
  // 上一次请求参数
  protected lastParams: TypePayAccountList.SearchData = {};
  // 页码总数
  protected total: number = 0;

  protected payId: string = '';
  protected editDisabled: boolean = false;

  protected payLogId: string = '';
  /** 是否枚举 */
  private yesNoStatus: TypeBase.EnumListItem[] = yesNoStatus;
  @Watch('$route.params', { deep: true })
  protected onPayAccountChange(params: { pay_account_name?: string, fill_extend?: string }): void {
    if (params.pay_account_name) {
      this.searchData.code_value = params.pay_account_name;
    }
    const fillExtend = Number(params.fill_extend);
    if (fillExtend) {
      this.searchData.fill_extend = fillExtend;
    }
    this.handleSearch(false);
  }
  protected created(): void {
    this.searchData = this.getInitSearchData();
    this.onPayAccountChange(this.$route.params);
    const h = this.$createElement;
    this.columns = [
      {
        title: this.t('账户名'),
        name: 'pay_account_name',
        width: 180,
        scopedSlots: { customRender: 'pay_account_name' },
        disabled: true,
      },
      {
        title: this.t('银行'),
        dataIndex: 'pay_bank_name',
        name: 'pay_bank_name',
        width: 180,
        isCopy: true,
      },
      {
        title: this.t('账号'),
        dataIndex: 'pay_account',
        name: 'pay_account',
        width: 180,
        isCopy: true,
      },
      {
        title: this.t('可充值币种'),
        scopedSlots: { customRender: 'currency_codes' },
        width: 300,
        name: 'currency_codes',
      },
      {
        title: this.t('充值账户'),
        scopedSlots: { customRender: 'accountCode' },
        width: 300,
        name: 'accountCode',
      },
      {
        title: this.t('状态'),
        scopedSlots: { customRender: 'accountStatus' },
        width: 100,
        name: 'accountStatus',
      },
      {
        title: () => {
          const h = this.$createElement;
          return <div>
            {this.t('是否支持线上充值')}
            <a-popover>
              <div slot='content'>
                <div>{this.t('Payoneer的付款账号，点击授权并成功后，将支持在线充值，充值金额实时到账。')}</div>
                <div>{this.t('PINGPONG的付款账号，点击授权并成功后，将支持在线充值，充值到账金额具体以谷仓财务审核实际到账的金额为准。')}</div>
              </div>
              <a-icon type='question-circle' class='ml-5' />
            </a-popover>
          </div>;
        },
        scopedSlots: { customRender: 'is_online_recharge' },
        name: 'is_online_recharge',
        label: this.t('是否支持线上充值'),
      },
      {
        // title: this.t('受托关系'),
        filterEmpty: true,
        scopedSlots: {
          title: 'fiduciary_title',
          customRender: 'fiduciary',
        },
        name: 'fiduciary',
        label: this.t('受托关系'),
      },
      {
        title: this.t('免责声明'),
        dataIndex: 'accept_text',
        name: 'accept_text',
        filterEmpty: true,
        width: 100,
      },
      {
        // title: this.t('是否第三方支付'),
        filterEmpty: true,
        scopedSlots: {
          title: 'is_unofficial_title',
          customRender: 'is_unofficial',
        },
        name: 'is_unofficial',
        label: this.t('是否第三方支付'),
      },
      {
        title: this.t('操作'),
        dataIndex: 'operation',
        name: 'operation',
        fixed: 'right',
        scopedSlots: { customRender: 'operation' },
        width: 200,
        showColumnSetting: true,
      },
    ];
    this.queryAccountList();
    this.queryBankList();
    if (this.$route.params.pay_account_name || !this.$util.isEmpty(this.$route.params.fill_extend)) {
      return;
    }
    this.queryInvoiceList();
  }
  /**
   * 获取下载地址
   */
  protected getDownloadUrl(path: string): string {
    return `${this.$config.rfsFileDownloadUrl}?path=${path}&download=1`;
  }
  /**
   * 付款账户列表
   * 是否清除params隐藏传参
   */
  protected async queryInvoiceList(isClearParams: boolean = true): Promise<void> {
    if (isClearParams) {
      /** 跳转页面隐藏参数，查询之后清楚该数据 */
      this.searchData.fill_extend = undefined;
    }
    const postData: TypePayAccountList.SearchData = this.$util.deepCopy(this.searchData);
    if (postData.code_field === 'pay_account_name') {
      postData.pay_account_name = postData.code_value;
    } else {
      postData.pay_account = postData.code_value;
    }
    postData.code_field = undefined;
    postData.code_value = undefined;
    this.lastParams = this.$util.deepCopy(this.searchData);
    const { data } = await this.$api.finance.queryPayAccountList<TypeBase.ListResult<TypePayAccountList.ListItem[]>>(postData);
    const { list, total } = data;
    this.dataList = list;
    this.total = total;
  }


  // 获取账户列表
  protected async queryAccountList(): Promise<void> {
    const { data = [], code } = await this.$api.finance.queryAccountList<TypeBase.AccountItem[]>();
    this.accountList = data.map((item: TypeBase.AccountItem) => ({
      ...item,
      sign_business_list_text: item.sign_business_list.map((it: TypeFinance.SignBusinessItem) => it.key).join(','),
    }));
  }
  /**
   * 获取支付账号详情
   */
  protected async queryPayAccountDetail(param: { id: string }): Promise<TypePayAccountList.FromData> {
    const { data } = await this.$api.finance.queryPayAccountDetail<TypePayAccountList.FromData>(param);
    return data;
  }
  /** 获取银行列表 */
  protected async queryBankList(): Promise<void> {
    const { data = [], code } = await this.$api.finance.queryBankList();
    this.bankList = data;
  }
  /** 获取pingpong授权信息 */
  protected async queryPingPongAuthorizeInfo(param: TypeFinance.PingPongAuthorizeInfoParam): Promise<TypeFinance.PingPongAuthorizeInfoResp> {
    const { data } = await this.$api.finance.queryPingpongAuthorizeInfo(param);
    return data;
  }
  /** p卡授权 */
  protected async payAccountAuthorize(param: TypePayAccountList.PayAuthorizationParam, item: TypePayAccountList.ListItem): Promise<void> {
    const { data } = await this.$api.finance.payAccountAuthorize(param);
    if (data.is_payment_letter) {
      const formData = await this.queryPayAccountDetail({
        id: param.customer_pay_info_id,
      });
      formData.id = param.customer_pay_info_id;
      this.openLetterOfEntrustment(formData, item);

    } else {
      this.$message.success(this.t('授权成功'));
    }
    this.queryInvoiceList();
  }
  /** pingpong授权 */
  protected async pingpongAccountAuthorize(id: string, item: TypePayAccountList.ListItem): Promise<void> {
    const formData = await this.queryPayAccountDetail({
      id,
    });
    if (formData.sign_body_name !== formData.pay_account_name) {
      formData.id = id;
      await this.openLetterOfEntrustment(formData, item);
    } else {
      this.$message.success(this.t('授权成功'));
    }
    this.queryInvoiceList();
  }
  /**
   * 解除p卡授权
   */
  protected async payAccountUnAuthorize(param: TypePayAccountList.PayUnAuthorizationParam): Promise<void> {
    await this.$api.finance.payAccountUnAuthorize(param);
    this.$message.success(this.t('解绑成功'));
    this.queryInvoiceList();
  }
  /**
   * 解除pingpong授权
   */
  protected async pingpongUnAuthorize(param: TypeFinance.PingPongAuthorizeUnbind): Promise<void> {
    await this.$api.finance.unBindPingpongAuthorize(param);
    this.$message.success(this.t('解绑成功'));
    this.queryInvoiceList();
  }
  /**
   * 上传委托函
   */
  protected openLetterOfEntrustment(data: TypePayAccountList.FromData, item: TypePayAccountList.ListItem): void {
    if (!data.pay_account_name) {
      this.$message.warning(this.t('账号名称不存在'));
      return;
    }
    const title = this.getPlatformNameByType(item.pay_bank_type);
    const contentNode = (h: CreateElement) => {
      const node = <div>
        <p>{this.t('系统检测到您当前授权的{0}账户主体名称({1})与需要充值的签约主体名称({2})不一致，请确认委托付款函。如已上传正确的委托付款函，可直接点击确定。', [title, data.pay_account_name, data.sign_body_name])}</p>
        <ul class='no-thead-table'>
          <li calss='no-thead-table-row'>
            <ul class='no-thead-table-row-box'>
              <li class='no-thead-table-cell'>
                {item.account_code}
              </li>
              <li class='no-thead-table-cell'>
                {item.sign_body_name}
              </li>
              <li class='no-thead-table-cell'>
                {item.sign_business_type_text}
              </li>
              <li class='no-thead-table-cell'>
                <my-upload class='add-upload mr-10'
                  style='display: inline-block'
                  data='[]'
                  ext-list={['png', 'jpg', 'pdf', 'zip']}
                  name='file'
                  before-upload={(file: File) => this.onBeforeUpload_prove_file(file, item, data, () => {
                    modal.update({ content: contentNode });
                  })}
                  validate-type='PayAttachmentRule'>
                  <a class='btn'
                    href='javascript:;'>{this.t('上传委托付款函')}</a>
                </my-upload>
                {data.attachment_url ? <a href={this.getDownloadUrl(data.attachment_url)}>
                  <a-icon style={{ color: '#FF9900' }} type='container' />
                </a> : ''}
              </li>
            </ul>
          </li>
        </ul>
        <p class='mt-10'>{this.t('委托函支持文件格式有：png、jpg、pdf、zip')}</p>
      </div>;
      return node;
    };
    const modal = this.$confirm({
      title: this.t('{0}授权', [title]),
      width: 700,
      class: 'payonner-modal-box',
      content: contentNode,
      okText: this.t('确认'),
      onOk: async () => {
        if (!data.attachment_url) {
          this.$message.warning(this.t('请上传委托付款涵'));
          return;
        }
        await this.modifyAttachmenturl(data);
        return Promise.resolve();
      },
    });
  }
  /**
   * 获取pingpong的授权地址
   */
  protected async queryPingpongAuthorizeUrl(param: TypeFinance.PingPongAuthorizeUrlParam): Promise<string> {
    const { data } = await this.$api.finance.queryPingpongAuthorizeUrl(param);
    return data.authorize_url;
  }
  /**
   * 编辑付款账号
   */
  protected async modifyAttachmenturl(data: TypePayAccountList.FromData): Promise<void> {
    const res = await this.$api.finance.modifyAttachmenturl({
      id: data.id || '',
      attachment_url: data.attachment_url || '',
    });
    if (res.code === 0) {
      this.$message.success(this.t('提交成功'));
      this.queryInvoiceList();
      // 刷新父页面
      this.$emit('success');
    }
  }
  protected async onBeforeUpload_prove_file(file: File, item: any, form: TypePayAccountList.FromData, callback: () => void): Promise<void> {
    // index 为-1时，编辑时委托付款函
    const formData = new FormData();
    formData.append('file', file);
    const { data, code, message } = await this.$api.finance.uploadPayAccountAttachment<TypeBase.AttachmentItem>(formData);
    if (code === 0) {
      this.$message.success(this.t('上传成功'));
      form.attachment_url = data.file_path;
      typeof callback === 'function' && callback();
    } else {
      this.$message.error(message);
    }
  }
  // 获取初始搜索
  @userPrefPageSize('payAccountList')
  protected getInitSearchData(): TypePayAccountList.SearchData {
    return {
      page_index: 1,
      page_size: 10,
      pay_account_name: undefined,
      pay_account: undefined,
      pay_bank_code: undefined,
      account_code: undefined,
      pay_account_status: undefined,
      code_value: undefined,
      code_field: 'pay_account_name',
      fill_extend: undefined,
      is_unofficial: undefined,
    };
  }
  /** 通过类型获取平台名称 */
  protected getPlatformNameByType(type: number | null): string {
    switch (type) {
      case this.$enum.finance.RechargeChannel.PAYONEER:
        return 'Payoneer';
        break;
      case this.$enum.finance.RechargeChannel.PINGPONG:
        return 'PingPong';
        break;
      default:
        return '';
    }
  }
  /** p卡授权 */
  protected payoneerAuthorize(item: TypePayAccountList.ListItem, title: string): void {
    const modal = Modal.confirm({
      title: this.t('温馨提示'),
      content: this.t('请在{0}页面完成授权操作！', [title]),
      cancelText: this.t('未完成授权'),
      okText: this.t('已完成授权'),
    });
    // 接收子窗口返回的数据
    messenger.on('payoneerAuthorize', async (data: { code: string }) => {
      modal.destroy();
      this.payAccountAuthorize({
        code: data.code as string,
        account_id: item.account_id,
        customer_pay_info_id: item.customer_pay_info_id,
        redirect_uri: this.biz_list.payoneer_callback_url,
      }, item);
    });
    messenger.on('payoneerAuthorizeError', async () => {
      modal.destroy();
      this.$message.error(this.t('授权失败'));
    });
  }
  /** pingpong授权 */
  protected pingPongAuthorize(item: TypePayAccountList.ListItem, title: string): void {
    const h = this.$createElement;
    const modal = Modal.confirm({
      title: this.t('温馨提示'),
      width: 800,
      content: <div>
        <p>{this.t('请在{0}页面完成授权操作。', [title])}</p>
        <div class='note-desc' style='font-size: 14px'>
          <div>{this.t('如页面未正常跳转PINGPONG平台无法完成授权操作，那可能是因为弹出页面行为被浏览器阻止了。')}</div>
          <div>{this.t('谷歌浏览器客户，请参考一下设置尝试解决问题：')}</div>
          <div>{this.t('1. 设置-隐私设置和安全性-网站设置-弹出式窗口和重定向；')}</div>
          <div>{this.t('2. 设置勾选允许网站发送弹出式窗口并使用重定向；')}</div>
          <p>{this.t('其他浏览器类似设置，如您有操作上的疑问，可以联系我们的客户协助。')}</p>
        </div>
        <a-popover placement='right'>
          <div slot='content'>
            <img src={require('@/assets/images/allowWindowOpen.png')} style='width: 700px; height: 360px;' />
          </div>
          <a href='javascript:'>{this.t('查看设置指引>')}</a>
        </a-popover>
      </div>,
      cancelText: this.t('未完成授权'),
      okText: this.t('已完成授权'),
    });
    // 接收子窗口返回的数据
    messenger.on('authorize', async (data: { code: string }) => {
      modal.destroy();
      this.pingpongAccountAuthorize(item.customer_pay_info_id, item);
    });
    messenger.on('authorizeError', async () => {
      modal.destroy();
      this.$message.error(this.t('授权失败'));
    });
  }
  /**
   * 获取平台授权链接
   */
  protected async getAuthorizeUrlByPlatform(item: TypePayAccountList.ListItem): Promise<string> {
    switch (item.pay_bank_type) {
      case this.$enum.finance.RechargeChannel.PAYONEER:
        return this.biz_list.payoneer_author_url;
        break;
      case this.$enum.finance.RechargeChannel.PINGPONG:
        return await this.queryPingpongAuthorizeUrl({
          customer_pay_info_id: item.customer_pay_info_id,
        });
        break;
      default:
        return '';
    }
  }
  /**
   * 前往授权
   */
  protected async gotoAuthorize(item: TypePayAccountList.ListItem, platformTitle: string): Promise<void> {
    const width = 600;
    const height = 650;
    const y = (window.screen.height - height) / 2;
    const x = (window.screen.width - width) / 2;
    const win = window.open('', this.t('{0}授权', [platformTitle]), `height=${height},width=${width},left=${x},top=${y},z-look=true;centerscreen=true;dialog=true;`);
    const url = await this.getAuthorizeUrlByPlatform(item);
    if (win) {
      win.location.href = url;
      if (item.pay_bank_type === this.$enum.finance.RechargeChannel.PAYONEER) {
        this.payoneerAuthorize(item, platformTitle);
      } else {
        this.pingPongAuthorize(item, platformTitle);
      }
    }
  }
  // 页码变动
  protected handlePageChange(val: number): void {
    this.searchData.page_index = val;
    this.queryInvoiceList(false);
  }
  // 点击每个tab的回调
  protected handleTabChange(key: string): void {
    this.initPage();
    this.queryInvoiceList();
  }
  // 重置页面数据
  protected initPage(): void {
    this.searchData.page_index = 1;
    this.selectedList = [];
  }
  // 搜索按钮
  protected handleSearch(isClearParams: boolean = true): void {
    this.initPage();
    this.queryInvoiceList(isClearParams);
  }
  // 清空
  protected handleReset(): void {
    this.searchData = this.getInitSearchData();
    this.queryInvoiceList();
  }
  // 导出
  protected async handleExport(isAll: boolean): Promise<void> {
    let postData: TypePayAccountList.ExportSearchData = {};
    if (isAll) {
      postData = { ...this.lastParams };
      delete postData.page_index;
      delete postData.page_size;
      postData.export = 1;
      postData.invoice_manage_id_list = [];
    } else {
      if (!this.selectedList.length) {
        return this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip));
      }
      postData.export = 2;
      postData.invoice_manage_id_list = this.selectedList;
    }
    const { code, data, message } = await this.$api.finance.queryInvoiceExport<TypeBase.ExcelDataResult>(postData);
    if (code === 0) {
      this.$util.exportExcel(data);
    } else {
      this.$message.error(message);
    }
  }

  /**
   * 授权
   */
  protected handleAuthorize(item: TypePayAccountList.ListItem): void {
    const h = this.$createElement;
    const title = this.getPlatformNameByType(item.pay_bank_type);
    const content = item.pay_bank_type === this.$enum.finance.RechargeChannel.PINGPONG ?
      this.t('是否确定授权{0}账户，绑定后将可进行在线充值。', [title]) :
      this.t('是否确定授权{0}账户，绑定后将可进行在线充值，实时到账。', [title]);
    const isPayOneer = item.pay_bank_type === this.$enum.finance.RechargeChannel.PAYONEER;
    this.$confirm({
      title: this.t('{0}授权', [title]),
      content: <div>
        <p>{content}</p>
        {
          isPayOneer
            ? <p class='note-tip mt-30'>{this.t('注：授权成功后，如果授权账户的账户名与账号与过去维护的不一致且未授权当前谷仓账号的其他付款账户，将自动更新为授权账户的账户名称和账号。')}</p>
            : <p class='note-tip mt-30'>{this.t('注：授权成功后，如果授权账户的账户名与账号与过去维护的不一致，将自动更新为授权账户的账户名称和账号。')}</p>
        }
      </div>,
      okText: this.t('去授权'),
      onOk: () => {
        this.gotoAuthorize(item, title);
      },
    });
  }
  /**
   * 解除授权
   */
  protected handleUnAuthorize(item: TypePayAccountList.ListItem): void {
    const title = this.getPlatformNameByType(item.pay_bank_type);
    this.$confirm({
      title: this.t('解除{0}授权', [title]),
      content: this.t('请确认解除{0}授权', [title]),
      onOk: () => {
        if (item.pay_bank_type === this.$enum.finance.RechargeChannel.PAYONEER) {
          this.payAccountUnAuthorize({
            customer_pay_info_id: item.customer_pay_info_id,
          });
        } else if (item.pay_bank_type === this.$enum.finance.RechargeChannel.PINGPONG) {
          this.pingpongUnAuthorize({
            customer_pay_info_id: item.customer_pay_info_id,
            account_code: item.account_code,
          });
        }
      },
    });
  }
  protected async handleDetail(payId: string) {
    const detailModal = this.$refs.detailModal as detailModal;
    detailModal.modalVisible = true;
    detailModal.detailData = {};
    const { data } = await this.$api.finance.queryPayAccountDetail<TypePayAccountList.FromData>({
      id: payId,
    });
    detailModal.detailData = data;
  }
  protected handleEdit(record: TypePayAccountList.ListItem) {
    this.payId = record.customer_pay_info_id;

    if (record.pay_account_status === String(this.$enum.finance.PayAccountStatusEnum.APPROVE)) {
      this.editDisabled = true;
    } else {
      this.editDisabled = false;
    }

    // 显示编辑窗口
    const addView = this.$refs.addOrEditRef as addOrEdit;
    addView.visible = true;
  }

  protected handleAdd() {
    this.payId = '';
    this.editDisabled = false;
    // 显示添加窗口
    const editView = this.$refs.addOrEditRef as addOrEdit;
    editView.visible = true;
  }

  protected async handleDelete(payId: string) {
    this.$confirm({
      title: this.tc('温馨提示'),
      content: this.t(`请确认是否删除该付款账户？`),
      onOk: async () => {
        // 删除
        const res = await this.$api.finance.deletePayAccount({ id: payId });
        if (res.code === 0) {
          this.$message.success(this.tc('删除成功'));
          // 刷新页面
          this.queryInvoiceList();
        }
      },
    });
  }

  protected handleShowLog(id: string) {
    this.payLogId = id;
    console.log(this.payLogId);
    // 显示日志
    const logsView = this.$refs.logsRef as Logs;
    logsView.visible = true;
  }

  protected handleSuccess() {
    this.queryInvoiceList();
  }

}
